// JS Dependency
var parsleyjs = require('parsleyjs');
var lang = $("html").attr('lang').slice(0,2);
if(lang=='fr'){
    var parsleyjs_fr = require('parsleyjs/dist/i18n/fr.js');
}

// Initialisation
$('.parsley-validate').parsley();
